import React from 'react';
import {Col, Container, Row} from 'reactstrap';
import classNames from 'classnames';
import CheckoutButton from 'components/CheckoutButton';
import './Guarantee.scss';
import {usePhaseState} from 'funnel-schedule/phase-context';

export function GuaranteeWrap({title, children, ...props}) {
  return (
    <div className={classNames(`guarantee-box rounded background-white box-shadow-black-50`, props.className)}>
      <h2 className="section-heading guarantee-heading text-center text-sm-left">{title}</h2>
      {children}
    </div>
  );
}

export default function Guarantee(props) {
  return (
    <GuaranteeWrap
      title={
        <>
          You’re Protected By Our <br className="d-none d-sm-block" />
          60-Day, Unconditional, <br className="d-none d-md-block" />
          Money-Back Guarantee.
        </>
      }
    >
      <p>
        Try it out. If you aren't completely blown away by the course, even if you just don’t like it, just email us to
        ask, at <a href="mailto:support@foodrevolution.org">support@foodrevolution.org</a>, any time within 60 days
        after purchase, for a prompt and courteous refund. This means you can even take the whole course, take every
        lesson, and make every single mouth-watering recipe, and if it doesn’t rock your world, you get every penny
        back. That’s how confident we are that you’ll LOVE Brain Health!
      </p>
      <p>
        PLUS, if for any reason you request a refund, the entire <em>Brain Health</em> course — everything that you’ve
        downloaded — is still yours to keep. That’s why we call our guarantee “better than money back.”
      </p>
    </GuaranteeWrap>
  );
}

export function GuaranteeBox({title, children, ...props}) {
  return (
    <div className={classNames(`guarantee-box rounded background-white box-shadow-black-50`, props.className)}>
      <h2 className="section-heading guarantee-heading text-center text-sm-left">{title}</h2>
      {children}
    </div>
  );
}
